/**
 * Backend provides only two types: Svg for SVGs and Jpeg for all the rest
 */
export const imageType = {
  VECTOR: 'svg',
  RASTER: 'jpeg',
  WEBP: 'webp',
} as const
